import {Brick, ErrorFlow, registerBrick, Transaction, QueryResult, BrickContext} from 'olympe';
import Picture from "../../../models/Picture";

export default class UpdatePictureRank extends Brick {

    /**
     * @override
     * @param {!BrickContext} $
     * @param {Picture} picture
     * @param {number} newRank
     * @param {Array | QueryResult} list
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    update($, [picture, newRank, list], [forwardEvent, setErrorFlow]) {
        const currentRank = /** @type {number} */ (picture.get(Picture.rankProp));

        if (newRank < 0 || newRank >= list.length) {
            setErrorFlow(ErrorFlow.create(`Rank is outside the boundaries: ${newRank}`, 1));
            return;
        }

        if (currentRank === newRank) {
            forwardEvent();
            return;
        }

        const transaction = new Transaction();
        transaction.update(picture, Picture.rankProp, newRank);
        const pictures = list.map(([pic]) => pic);

        if (currentRank < newRank) {
            for (let i = currentRank + 1; i <= newRank; i++) {
                transaction.update(pictures[i], Picture.rankProp, i - 1);
            }
        } else {
            for (let i = newRank; i < currentRank; i++) {
                transaction.update(pictures[i], Picture.rankProp, i + 1);
            }
        }

        transaction.execute().then(forwardEvent).catch((e) => {
            setErrorFlow(ErrorFlow.create(`Error while updating ranks of pictures: ${e}`, 2));
        });
    }
}

registerBrick('018aadeb375f14456d1b', UpdatePictureRank);
